var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPromotion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 4.18884V4.75134L7.67578 4.15369C9.01172 3.83728 10.418 3.97791 11.6484 4.61072C13.2656 5.41931 15.1992 5.41931 16.8164 4.61072L17.168 4.43494C17.8711 4.08337 18.75 4.61072 18.75 5.41931V14.1029C18.75 14.5951 18.4336 14.9818 18.0117 15.1576L16.7812 15.6146C15.1641 16.2474 13.3711 16.142 11.7891 15.3685C10.4531 14.7006 8.94141 14.5248 7.5 14.8763L5.25 15.4388V19.9388C5.25 20.5717 4.72266 21.0638 4.125 21.0638C3.49219 21.0638 3 20.5717 3 19.9388V16.0013V5.31384V4.18884C3 3.59119 3.49219 3.06384 4.125 3.06384C4.72266 3.06384 5.25 3.59119 5.25 4.18884Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotion);
export default ForwardRef;